import { CALL_API, METHOD_TYPE } from '../../middleware/api.middleware'

/**
 * Change Request Action Type Constants
 * @type {string}
 */
export const CREATE_CHANGE_REQUEST_REQUEST = 'CREATE_CHANGE_REQUEST_REQUEST'
export const CREATE_CHANGE_REQUEST_SUCCESS = 'CREATE_CHANGE_REQUEST_SUCCESS'
export const CREATE_CHANGE_REQUEST_FAILURE = 'CREATE_CHANGE_REQUEST_FAILURE'

export const GET_CHANGE_REQUESTS_REQUEST = 'GET_CHANGE_REQUESTS_REQUEST'
export const GET_CHANGE_REQUESTS_SUCCESS = 'GET_CHANGE_REQUESTS_SUCCESS'
export const GET_CHANGE_REQUESTS_FAILURE = 'GET_CHANGE_REQUESTS_FAILURE'

/**
 * CREATE Change Requests
 * @param params
 * @param options
 * @returns {{}}
 */
const _createChangeRequest = (data) => ({
  [CALL_API]: {
    types: [
      CREATE_CHANGE_REQUEST_REQUEST,
      CREATE_CHANGE_REQUEST_SUCCESS,
      CREATE_CHANGE_REQUEST_FAILURE
    ],
    method: METHOD_TYPE.POST,
    endpoint: '/changeRequest',
    payload: data
  }
})

/**
 * GET Change Requests list
 * @param {*} params 
 * @param {*} options 
 * @returns 
 */
export const _getChangeRequests = (params, options = {}) => ({
  [CALL_API]: {
    types: options.types || [
      GET_CHANGE_REQUESTS_REQUEST,
      GET_CHANGE_REQUESTS_SUCCESS,
      GET_CHANGE_REQUESTS_FAILURE
    ],
    method: METHOD_TYPE.GET,
    endpoint: '/changeRequest',
    payload: params
  }
})

/**
 * Dispatch GET_CONTACTS_REQUEST
 * @param params
 */
export const getChangeRequests = (params) => (dispatch) => {
  return dispatch(_getChangeRequests(params))
}

/**
 * Dispatch CREATE_CONTACT_REQUEST
 * @param params: data, profile
 */
export const createChangeRequest = (params) => (dispatch) => {
  const data = {
    ..._createContactPayload(params.values, params.profile),
   change_request: {
      type: params.change_type,
      status: "pending",
      timestamp: new Date() 
    },

  }
  return dispatch(_createChangeRequest(data))
}


/**
 * Create revision object to push
 * @param notes
 * @param profile
 * @returns {{notes: (*|string), author: (*|string), update_date: Date}}
 */
const getRevisionObject = (notes, profile) => {
  return {
    update_date: new Date(),
    author: profile?.name,
    notes: notes.trim()
  }
}
/**
 * Convert contact form values to model expected from API
 * @param data
 * @param profile
 * @returns {*}
 * @private
 */
const _createContactPayload = (data, profile) => {
  if (!data) {
    return {}
  }

  return {
    _id: data.id,
    source: 'people_ssot',
    status: data.status || null,
    salutation: data.salutation,
    suffix_prof: data.suffixProf,
    first_name: data.firstName,
    last_name: data.lastName,
    full_name: []
      .concat(data.firstName, data.middleName1, data.middleName2, data.lastName)
      .filter((name) => name?.trim()).join(' '),
    nickname: data.nickName,
    middle_name1: '', // @deprecated
    middle_name2: '', // @deprecated
    maternal_name: '', // @deprecated
    maiden_name: '', // @deprecated
    first_name_pronunciation: '', // @deprecated
    last_name_pronunciation: '', // @deprecated
    email: data.email,
    direct_phone: data.directPhone,
    phone_extension: data.directPhone ? data.phoneExtension : '',
    mobile: data.mobile,
    linkedin_url: data.linkedIn,
    company_website1: data.website1,
    company_website2: data.website2,
    fca_url: data.fca,
    sec_url: data.sec,
    finra_url: data.finra,
    bio: (data.bio || '').replace(/[\r\n]/g, '\\n'),
    title: data.title,
    jobs: data.jobs || [],
    revision: (data?.notes?.trim()?.length) ? getRevisionObject(data.notes, profile) : null,
    managed_funds: data.managedFunds || [],
    gdpr: data.gdpr || []
  }
}


